// extracted by mini-css-extract-plugin
export default {"footer":"iibTD","mobileFooter":"aJS74","container":"kB0Ju"};